<template>
    <div class="modal" ref="modal" @click.self="closeSlider" tabindex="0" @keyup.esc="closeSlider">
        <div class="modal-content">
            <div class="modal-close" @click="closeSlider">
                <icon-close/>
            </div>
            <div id="testPhotosCarousel" class="slick-container">
                <Slick :options="options" ref="carousel" @swipe="videoPause()">
                    <div v-for="(item, index) in slides" :key="index">
                        <div v-if="isVideo(item.url)" class="slider-video">
                            <button type="button" class="slider-video-btn" :class="{hidden: isPlaying}" @click="videoPlay($event)">
                                <icon-type-video class="slider-video-icon"/>
                            </button>
                            <video preload="preload" playsinline :ref="`video-${index}`"
                                   @play="videoPlayHandler(`video-${index}`)"
                                   @pause="videoPauseHandler(null)" :autoplay="index == start"
                                   controls
                                   :src="item.url" width="1200" height="600">
                            </video>
                        </div>
                        <img v-else :src="item.url" :alt="item.name" width="1200" height="600" class="slider-image">
                    </div>
                </Slick>
                <button v-if="!isMobile && slides.length > 1" type="button" @click="swipePrev" class="slick-arrow slick-prev">
                    <icon-slide-prev/>
                </button>
                <button v-if="!isMobile && slides.length > 1" type="button" @click="swipeNext" class="slick-arrow slick-next">
                    <icon-slide-next/>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Slick from 'vue-slick'
import IconClose from '../icons/IconClose'
import IconSlidePrev from '../icons/iconSlidePrev.vue'
import IconSlideNext from '../icons/iconSlideNext.vue'
import 'slick-carousel/slick/slick.css'
import IconTypeVideo from '../icons/IconTypeVideo.vue'

export default {
    name: "TestItemCarousel",
    components: { IconTypeVideo, IconSlideNext, IconSlidePrev, Slick, IconClose},
    props: ['slides', 'start', 'isMobile'],
    data() {
        return {
            options: {
                arrows: false,
                dots: true,
                infinite: false,
                speed: 500,
                initialSlide: this.start,
                touchThreshold: 35,
                edgeFriction: 0.15,
                swipeToSlide: true,
                waitForAnimate: this.isMobile,
            },

            isPlaying: false,
            playVideoId: null,
        }
    },
    mounted () {
        this.$refs.modal.focus()
    },
    methods: {
        closeSlider() {
            this.$emit('closeslider');
        },
        swipeNext() {
            this.$refs.carousel.next();
            this.videoPause();
        },
        swipePrev() {
            this.$refs.carousel.prev();
            this.videoPause();
        },
        isVideo(url) {
            const videoExtensions = /\.(mp4|avi|mov|mkv|flv|wmv|webm|ogg)$/i;
            return videoExtensions.test(url);
        },
        videoPause() {
            if (!this.playVideoId) {
                return;
            }

            this.$refs[this.playVideoId][0].pause();
        },
        videoPlay (event) {
            event.target.closest('button').nextElementSibling.play()
        },
        setPlayVideoId(id) {
            this.playVideoId = id;
        },
        videoPlayHandler(id) {
            this.setPlayVideoId(id);
            this.isPlaying = true;
        },
        videoPauseHandler(id) {
            this.setPlayVideoId(id);
            this.isPlaying = false;
        }
    },
}
</script>
<style lang="scss">

@import "../../../../sass/front/helpers";

#testPhotosCarousel {
    width: 100%;
    position: relative;

    .slick-slider {
        width: 100%;
    }

    .slick-slide {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .slick-arrow {
        position: absolute;
        top: calc(50% - 3rem);
        z-index: 2;
        cursor: pointer;
        background: #F8F8F8;
        width: 42px;
        height: 42px;
        border-radius: 50%;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background-color 0.3s;

        &:hover {
            background: #EFEFEF;
        }

        &:focus {
            outline: none;
        }
    }

    .slick-prev {
        left: -10px;
        transform: translate(-100%, -50%);
    }

    .slick-next {
        right: -10px;
        transform: translate(100%, -50%);
    }

    .slick-dots {
        margin-top: 10px;
        width: 100%;
        display: flex !important;
        align-items: center;
        justify-content: center;

        li {
            padding: 5px;
        }

        button {
            display: block;
            font-size: 0;
            line-height: 0;
            background: #DADADA;
            width: 1rem;
            height: 1rem;
            padding: 0;
            border-radius: 50%;
            border: none;
            cursor: pointer;
        }

        li.slick-active button {
            background: #262626;
        }
    }
}

.modal {
    background: rgba(0, 0, 0, 0.38);
    position: fixed;
    z-index: 100;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    padding: 20px;
    @extend .flex-center;

    &-content {
        background: #FFFFFF;
        border-radius: 16px;
        padding: 80px 100px;
        position: relative;
        width: 100%;
        max-width: 1200px;
        max-height: calc(100vh - 20px);

        @include responsive-below($md) {
            padding: 60px 40px 20px;
        }

        @include responsive-below($xs) {
            padding: 20px;
        }
    }

    &-close {
        position: absolute;
        right: 24px;
        top: 24px;
        background-color: #EFEFEF;
        border-radius: 10px;
        width: 44px;
        height: 44px;
        cursor: pointer;
        transition: background-color 0.3s;
        @extend .flex-center;

        @include responsive-below($md) {
            right: 16px;
            top: 16px;
        }

        @include responsive-below($xs) {
            right: 0;
            top: -50px;
        }

        &:hover {
            background-color: #F8F8F8;
        }
    }
}

.slider-video {
    position: relative;
    max-width: 720px;
    width: 100%;
    margin: 0 auto;
    max-height: 66vh;

    video {
        width: 100%;
        height: auto;
        max-height: 100%;
        aspect-ratio: 16/9;
        border-radius: 8px;
        object-fit: contain;
        cursor: pointer;
    }

    &-btn {
        position: absolute;
        top: 46%;
        left: 50%;
        transform: translate(-50%, -50%) scale(1);
        display: grid;
        width: 100px;
        padding: 16px;
        aspect-ratio: 1;
        cursor: pointer;
        color: #fff;
        z-index: 2;
        opacity: 1;
        box-shadow: none;
        border: none;
        background: none;
        border-radius: 50%;
        transition: transform 0.3s ease-in-out, opacity 0.5s ease-in-out;

        @include responsive-below($xs) {
            width: 80px;
        }

        @media (hover: hover) {
            &:hover {
                transform: translate(-50%, -50%) scale(1.1);
            }
        }

        &.hidden {
            opacity: 0;
            pointer-events: none;
        }

        &::before {
            content: '';
            grid-column: 1/2;
            grid-row: 1/2;
            background-color: rgba(0, 0, 0, 0.4);
            width: 70%;
            height: 70%;
            margin: auto;
            border-radius: 50%;
        }
    }

    &-icon {
        position: relative;
        z-index: 2;
        grid-column: 1/2;
        grid-row: 1/2;
        width: 100%;
        height: auto;
        max-width: 100%;
    }
}

.slider-image {
    max-width: 100%;
    margin: 0 auto;
    max-height: 66vh;
    object-fit: contain;
}
</style>

